
<template>
  <div class="table-body">
    <div class="opt-btn">
      <!-- <el-button
        size="small"
        type="primary"
        v-if="hasBtnPermission('btn_law_enforcement_add')"
        icon="el-icon-plus"
        @click="routerAdd"
      >新增</el-button>
      <el-button
        size="small"
        type="primary"
        v-if="hasBtnPermission('btn_law_enforcement_add')"
        @click="routerAdd"
        plain
      >作废</el-button>
       -->
       <el-date-picker
      v-model="datePicker"
      type="year"
      format="yyyy 年"
      value-format="yyyy"
      @change="dateChangeHand"
         >
    </el-date-picker>
    </div>
    <el-table
      :data="annualTableData"
      class="table-content"
      v-loading="dataListLoading"
      :header-cell-style="this.$globalGrayTableHeaderStyle"
      ref="multipleTable1"
      :height="tableMaxHeight"
      stripe
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column fixed type="selection" align="center"></el-table-column>
      <el-table-column
        fixed
        type="index"
        align="center"
        label="序号"
        width="60"
        :index="getRowsIndex"
      ></el-table-column>
      <el-table-column
        label="状态"
        prop="status"
        align="center"
        width="90px"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <i :class="formatterStatusClass(scope.row.status)"></i>
          <span>{{formatterStatusName(scope.row.status)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="归属年份"
        prop="year"
        align="center"
        width="130"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{scope.row.year + '年'}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="姓名"
        prop="name"
        align="center"
        width="90"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        label="身份证号"
        prop="idCard"
        align="center"
        width="150"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        label="评价得分"
        prop="value"
        align="center"
        width="250"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        label="排名"
        prop="sort"
        align="center"
        width="250"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        label="计算日期"
        prop="calculateTime"
        align="center"
        width="150"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{formatDate(scope.row.calculateTime,'yyyy-MM-dd HH:mm')}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="评价次数"
        prop="count"
        align="center"
        width="250"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        label="参与评价单位"
        prop="evaluationUnitsCount"
        align="center"
        width="250"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        label="创建时间"
        prop="createTime"
        align="center"
        width="100"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{formatDate(scope.row.createTime,'yyyy-MM-dd')}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="创建人员"
        prop="createUser"
        align="center"
        width="100"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="routerDetail(scope.row,'view')" v-if="hasBtnPermission('experts_eval_archives_view')">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="total"
      :current-page="pageIndex"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    ></el-pagination>
  </div>
</template>

<script>
// import {removeTabHandle} from '@/utils/routeTab';
import { getAnnualList } from "@/server/exports.js";
export default {
  props: [],
  components: {},
  data() {
    return {
      datePicker:new Date().getFullYear()+'',
      activeName: "daily",
      placeholderArea: "",
      searchKey: "",
      historyid: "",
      multipleSelection: [],
      tableMaxHeight: document.documentElement.clientHeight - 355,
      dataListLoading: false,
      pageSize: 10, //每页条数
      pageIndex: 1, //当前页
      total: 0, //总条数
      tableData: [],
      dailyTableData: [],
      annualTableData: [],
    };
  },
  created() {},
  activated() {
    this.getDataList();
  },
  methods: {
    dateChangeHand(val){
     this.getDataList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    formatterStatusClass(historyId) {
      switch (historyId) {
        case 2:
          return "icon-point icon-point-success";
          break;
        default:
          return "";
          break;
      }
    },

    formatterStatusName(historyId) {
      switch (historyId) {
        case 2:
          return "已备案";
          break;
       
        default:
          return "";
          break;
      }
    },
    getRowsIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },

    routerAdd() {
      removeTabHandle("eval_annual_detail");
      this.$router.push({
        name: "eval_annual_detail",
        query: {
          id: ""
        }
      });
    },
    routerDetail(item, type) {
      // 跳转详情

      if (type == "edit") {
        let id = (item && item.id) || "";
        removeTabHandle("eval_annual_detail");
        this.$router.push({
          name: "eval_annual_detail",
          query: {
            id: id
          }
        });
      }

      if (type == "view") {
        let id = (item && item.id) || "";
        removeTabHandle("eval_annual_detail");
        this.$router.push({
          name: "eval_annual_detail",
          query: {
            id: id
          }
        });
      }
    },
    getDataList(searchKey,superviseDeptCodeList) {
      // 获取列表数据

      this.searchKey = searchKey || "";
      if (searchKey) {
        this.pageIndex = 1;
      }
      getAnnualList({
        page: this.pageIndex,
        rows: this.pageSize,
        keyWord: this.searchKey,
        filter: {
          historyid: this.historyid,
          year:this.datePicker||'',
          superviseDeptCodeList:superviseDeptCodeList||[]
        }
      }).then((res) => {
          this.annualTableData = res.data.rows;
          this.total = res.data.total;
          this.$refs.multipleTable1.doLayout();
          this.dataListLoading = false;
      });
      // this.annualTableData = [
      //   {
      //     year: "2021",
      //     name: "石孟*",
      //     idCard: "410430********0062",
      //     historyid: 0,
      //     calculateTime: "2021-12-08",
      //     evalName: "临颍县建设工程招标投标管理办公室",
      //     changeTime: "2021-12-14 08:47:04",
      //     changeUser: "张志勤",
      //     createTime: "2021-12-08 19:46:22",
      //     createUser: "张志勤"
      //   },
      //   {
      //     year: "2021",
      //     name: "王耀*",
      //     idCard: "410430********0089",
      //     historyid: -1,
      //     calculateTime: "2021-12-08",
      //     evalName: "黄石市西城区建设与环境保护局",
      //     changeTime: "2021-12-14 08:47:04",
      //     changeUser: "张志勤",
      //     createTime: "2021-12-08 19:46:22",
      //     createUser: "张志勤"
      //   },
      //   {
      //     year: "2021",
      //     name: "张建*",
      //     idCard: "410430********0056",
      //     historyid: 0,
      //     calculateTime: "2021-12-08",
      //     evalName: "黄石市国土资源局召陵分局",
      //     changeTime: "2021-12-14 08:47:04",
      //     changeUser: "张志勤",
      //     createTime: "2021-12-08 19:46:22",
      //     createUser: "张志勤"
      //   },
      //   {
      //     year: "2021",
      //     name: "袁*",
      //     idCard: "410430********0023",
      //     historyid: 0,
      //     calculateTime: "2021-12-08",
      //     evalName: "黄石市水利局水利工程招标投标管理办公室",
      //     changeTime: "2021-12-14 08:47:04",
      //     changeUser: "张志勤",
      //     createTime: "2021-12-08 19:46:22",
      //     createUser: "张志勤"
      //   },
      //   {
      //     year: "2021",
      //     name: "李*",
      //     idCard: "410430********0014",
      //     historyid: 1,
      //     calculateTime: "2021-12-08",
      //     evalName: "临颍县建设工程招标投标管理办公室",
      //     changeTime: "2021-12-14 08:47:04",
      //     changeUser: "张志勤",
      //     createTime: "2021-12-08 19:46:22",
      //     createUser: "张志勤"
      //   }
      // ];
      // this.total = 200;
      this.$refs.multipleTable1.doLayout();

      // FIXME 接口待对接
      // this.dataListLoading=true;
      // this.$httpReq.post('/projectDoubleExtract/extracttask/list', {
      //     'page': this.pageIndex,
      //     'rows': this.pageSize,
      //     'keyWord': this.searchKey,
      //     'filter': {
      //         historyid:this.historyid,
      //     }
      // }).then(res => {
      //     this.annualTableData = res.data.rows;
      //     this.total = res.data.total;
      //     this.$refs.multipleTable1.doLayout();
      //     this.dataListLoading = false;
      // })
    }
  }
};
</script>
<style lang="scss" scoped>
$main-color: #1890ff;
.table-body {
  margin: 16px 24px;
  background: #ffffff;
  padding: 15px 24px;
  margin-bottom: 0;
  .opt-btn {
    margin-bottom: 16px;
  }
}
</style>
